class AppColors {
  constructor(options = {}, base) {
    var _a, _b, _c, _d, _e, _f;
    this.brandColor = (_a = options.brandColor) !== null && _a !== void 0 ? _a : base === null || base === void 0 ? void 0 : base.brandColor;
    this.brandColorDark = (_c = (_b = options.brandColorDark) !== null && _b !== void 0 ? _b : base === null || base === void 0 ? void 0 : base.brandColorDark) !== null && _c !== void 0 ? _c : false;
    this.brandLoginColor = (_d = options.brandLoginColor) !== null && _d !== void 0 ? _d : base === null || base === void 0 ? void 0 : base.brandLoginColor;
    this.brandLoginColorDark = (_f = (_e = options.brandLoginColorDark) !== null && _e !== void 0 ? _e : base === null || base === void 0 ? void 0 : base.brandLoginColorDark) !== null && _f !== void 0 ? _f : false;
  }
}

export { AppColors as default };
